import { Skeleton } from "antd";
import React from "react";

interface OverviewInfoProps {
  title: string;
  quantity?: number;
  rate?: number;
  periodLabel: string;
  loading: boolean;
  icon: string;
}

const numberFormat = new Intl.NumberFormat("vi-VN");
const percentFormat = new Intl.NumberFormat("vi-VN", { maximumFractionDigits: 1 });

// Một ô trong hàng số liệu: tổng hiện tại và thay đổi so với kỳ trước
export default function OverviewInfo(props: OverviewInfoProps) {
  const { title, quantity, rate, periodLabel, loading, icon } = props;
  const direction = rate == null || rate === 0 ? "flat" : rate > 0 ? "up" : "down";

  return (
    <div className="dashboard-master__stat">
      <div className="dashboard-master__stat-head">
        <span className="dashboard-master__stat-label">{title}</span>
        <span className="dashboard-master__stat-icon" aria-hidden>
          <i className={icon} />
        </span>
      </div>
      {loading ? (
        <Skeleton.Input active size="small" className="dashboard-master__stat-skeleton" />
      ) : (
        <>
          <div className="dashboard-master__stat-value">
            {quantity != null ? numberFormat.format(quantity) : "—"}
          </div>
          {rate != null && (
            <div className={`dashboard-master__stat-delta dashboard-master__stat-delta--${direction}`}>
              {direction !== "flat" && (
                <i className={direction === "up" ? "tio-arrow_upward" : "tio-arrow_downward"} aria-hidden />
              )}
              <span>
                {direction === "flat" ? "Không đổi" : `${percentFormat.format(Math.abs(rate) * 100)}%`}
              </span>
              <span className="dashboard-master__stat-period">so với {periodLabel}</span>
            </div>
          )}
        </>
      )}
    </div>
  );
}
